import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import { IRcaState } from "../store/IRcaState";
import { IServices } from "../services/IServices";
import { AppDispatch } from "../store/getStore";

export type RcaThunkDispatch = ThunkDispatch<IRcaState, IServices, AnyAction>;
export type RcaThunkArg<T = unknown> = {
  /**
   * The extra parameter (which is services)
   */
  extra: IServices;

  /**
   * For an async thunk action (which returns a promise), this allows
   * strong typing of the known Error type when that promise/thunk
   * is rejected (i.e. when an Exception/Error is thrown).
   */
  rejectValue: T;

  /**
   * The strongly-typed app dispatch type
   * This allows dispatching other actions from a thunk action.
   */
  dispatch: AppDispatch;

  /**
   * The strongly-typed app state available via `thunkApi.getState()`
   */
  state: IRcaState;
};

export const SET_LANGUAGE_COMPLETE = "SET_LANGUAGE_COMPLETE";
export const SET_AUTOFILL_ENABLED = "SET_AUTOFILL_ENABLED";
export const LOAD_TEST_RESULT_START = "LOAD_TEST_RESULT_START";
export const LOAD_TEST_RESULT_SUCCESS = "LOAD_TEST_RESULT_SUCCESS";
export const LOAD_TEST_RESULT_ERROR = "LOAD_TEST_RESULT_ERROR";
export const SET_TEST_RESULT_PROGRESS = "SET_TEST_RESULT_PROGRESS";
export const SET_TEST_NODE_EXPANDED = "SET_TEST_NODE_EXPANDED";
export const SET_TEST_NODE_EXPAND_COLLAPSE_ALL = "SET_TEST_NODE_EXPAND_COLLAPSE_ALL";
export const TOGGLE_NAV = "TOGGLE_NAV";
export const LOAD_TEST_INPUT_START = "LOAD_TEST_INPUT_START";
export const LOAD_TEST_INPUT_SUCCESS = "LOAD_TEST_INPUT_SUCCESS";
export const LOAD_TEST_INPUT_ERROR = "LOAD_TEST_INPUT_SUCCESS";
export const UPDATE_TEST_INPUT_FORM_DATA = "UPDATE_TEST_INPUT_FORM_DATA";
export const EXECUTE_TEST_START = "EXECUTE_TEST_START";
export const EXECUTE_TEST_SUCCESS = "EXECUTE_TEST_SUCCESS";
export const EXECUTE_TEST_THROTTLED = "EXECUTE_TEST_THROTTLED";
export const EXECUTE_TEST_USER_UNKNOWN = "EXECUTE_TEST_USER_UNKNOWN";
export const SET_SERVER_VALIDATION_ERRORS = "SET_SERVER_VALIDATION_ERRORS";
export const CLEAR_SERVER_VALIDATION_ERRORS = "CLEAR_SERVER_VALIDATION_ERRORS";
export const CLEAR_SPECIFIC_SERVER_VALIDATION_ERROR = "CLEAR_SPECIFIC_SERVER_VALIDATION_ERROR";
export const SET_USERNAME_HINT = "SET_USERNAME_HINT";
export const SET_FOCUSED_FIELD_ID = "SET_FOCUSED_FIELD_ID";
export const INIT_COOKIE_CONSENT = "INIT_COOKIE_CONSENT";
export const MANAGE_COOKIE_CONSENT = "MANAGE_COOKIE_CONSENT";
export const SET_COOKIE_CONSENT_REQUIRED = "SET_COOKIE_CONSENT_REQUIRED";
export const DISMISS_BANNER_COMPLETE = "DISMISS_BANNER_COMPLETE";
export const REFRESH_ANTIFORGERY_TOKEN = "REFRESH_ANTIFORGERY_TOKEN";
export const SET_THEME = "SET_THEME";
